export const IS_MOBILE = window && /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
